import { configureStore } from '@reduxjs/toolkit'
import { useSelector, type TypedUseSelectorHook, useDispatch } from 'react-redux'

import { authApi } from './api/authApi'
import userReducer from './features/userSlice'
import serviceReducer from './features/serviceSlice'
import { userApi } from './api/userApi'
import modeReducer from './features/modeSlice'
import { paymentApi } from './api/paymentApi'
import paymentReducer from './features/paymentSlice'
import intentReducer from './features/intentSlice'
import cardDlgSlice from './features/cardDlgSlice'
import createUserDlgSlice from './features/createUserDlgSlice'
import editUserDlgSlice from './features/editUserDlgSlice'
import { ihfApi } from './api/ihfApi'
import ihfReducer from './features/ihfSlice'
import productCategoriesSlice from './features/productCategoriesSlice'
import { supportApi } from './api/supportApi'
import { usersApi } from './api/usersApi'
import supportTicketsSlice from './features/supportTicketsSlice'
import createSupportTicketSlice from './features/createSupportTicketSlice'

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [ihfApi.reducerPath]: ihfApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    userState: userReducer,
    serviceState: serviceReducer,
    modeState: modeReducer,
    paymentState: paymentReducer,
    intentState: intentReducer,
    ihfState: ihfReducer,
    cardDlgState: cardDlgSlice,
    createUserDlgState: createUserDlgSlice,
    editUserDlgState: editUserDlgSlice,
    productCategoriesState: productCategoriesSlice,
    supportTicketsState: supportTicketsSlice,
    createTicketState: createSupportTicketSlice
  },
  devTools: process.env.NODE_ENV === 'development',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(
    [authApi.middleware, userApi.middleware, paymentApi.middleware, ihfApi.middleware, supportApi.middleware, usersApi.middleware]
  )
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
